export default "__VITE_ASSET__DL2cPT_a__"